import React, { useEffect, useState } from 'react';
import JsonData from './script-data.json';

interface DialogScript {
	step_name: string;
	instruction?: string;
	instruction_1?: string;
	instruction_2?: string;
	instruction_3?: string;
	instruction_4?: string;
	instruction_5?: string;
	instruction_6?: string;
	instruction_7?: string;
	dialog_script?: string[];
	dialog_script_1?: string[];
	dialog_script_2?: string[];
	dialog_script_3?: string[];
	dialog_script_4?: string[];
	dialog_script_5?: string[];
	dialog_script_6?: string[];
	dialog_script_7?: string[];
}

interface ScriptTabProps {
	data: any;
}

const ScriptTabContent: React.FC<ScriptTabProps> = ({ data }) => {
	const [currentIndex, setCurrentIndex] = useState(0);
	const [titleText, setTitleText] = useState<string>('');
	const [isFirstRender, setIsFirstRender] = useState(true);

	const currentItem: DialogScript = JsonData[currentIndex];

	useEffect(() => {
		setTitleText(data.step_name);
		if (data.no_refresh_flag) {
			return;
		}
		if (isFirstRender) {
			setIsFirstRender(false);
		} else {
			setCurrentIndex((prevIndex) => (prevIndex + 1) % JsonData.length);
		}
	}, [data]);



	const renderParagraph = (content: string, type: 'instruction' | 'dialog', key: number) => (
		<p
			key={key}
			className={`text-black text-xs m-0 leading-[18px] font-medium items-stretch ${type === 'instruction'
				? 'mb-2'
				: 'bg-[#E6F7FF] border border-[#ADD8E6] rounded-t-3xl rounded-bl-3xl p-3 mb-1'
				}`}
			dangerouslySetInnerHTML={{ __html: content }}
		/>
	);

	type CombinedDataItem = { content: string; type: 'instruction' | 'dialog' };

	const combinedData: CombinedDataItem[] = [];

	if (currentItem.instruction) combinedData.push({ content: currentItem.instruction, type: 'instruction' });
	if (currentItem.dialog_script) combinedData.push(...currentItem.dialog_script.map(script => ({ content: script, type: 'dialog' as 'dialog' })));
	if (currentItem.instruction_1) combinedData.push({ content: currentItem.instruction_1, type: 'instruction' });
	if (currentItem.dialog_script_1) combinedData.push(...currentItem.dialog_script_1.map(script => ({ content: script, type: 'dialog' as 'dialog' })));
	if (currentItem.instruction_2) combinedData.push({ content: currentItem.instruction_2, type: 'instruction' });
	if (currentItem.dialog_script_2) combinedData.push(...currentItem.dialog_script_2.map(script => ({ content: script, type: 'dialog' as 'dialog' })));
	if (currentItem.instruction_3) combinedData.push({ content: currentItem.instruction_3, type: 'instruction' });
	if (currentItem.dialog_script_3) combinedData.push(...currentItem.dialog_script_3.map(script => ({ content: script, type: 'dialog' as 'dialog' })));
	if (currentItem.instruction_4) combinedData.push({ content: currentItem.instruction_4, type: 'instruction' });
	if (currentItem.dialog_script_4) combinedData.push(...currentItem.dialog_script_4.map(script => ({ content: script, type: 'dialog' as 'dialog' })));
	if (currentItem.instruction_5) combinedData.push({ content: currentItem.instruction_5, type: 'instruction' });
	if (currentItem.dialog_script_5) combinedData.push(...currentItem.dialog_script_5.map(script => ({ content: script, type: 'dialog' as 'dialog' })));
	if (currentItem.instruction_6) combinedData.push({ content: currentItem.instruction_6, type: 'instruction' });
	if (currentItem.dialog_script_6) combinedData.push(...currentItem.dialog_script_6.map(script => ({ content: script, type: 'dialog' as 'dialog' })));
	if (currentItem.instruction_7) combinedData.push({ content: currentItem.instruction_7, type: 'instruction' });
	if (currentItem.dialog_script_7) combinedData.push(...currentItem.dialog_script_7.map(script => ({ content: script, type: 'dialog' as 'dialog' })));

	return (
		<div className="w-full">
			<h3 className="text-sm font-bold mb-2">{titleText}</h3>
			<div className='max-h-80 overflow-auto scriptWrapperScroll pr-2'>
				{combinedData.map((item, index) => renderParagraph(item.content, item.type, index))}
			</div>
		</div>
	);
};

export default ScriptTabContent;
